__turbopack_context__.v({
  "axisDot": "recurring-visual-module__Ig4nzG__axisDot",
  "axisDotActive": "recurring-visual-module__Ig4nzG__axisDotActive",
  "axisStrip": "recurring-visual-module__Ig4nzG__axisStrip",
  "dropdown": "recurring-visual-module__Ig4nzG__dropdown",
  "dropdownOpen": "recurring-visual-module__Ig4nzG__dropdownOpen",
  "fieldValue": "recurring-visual-module__Ig4nzG__fieldValue",
  "fieldValueVisible": "recurring-visual-module__Ig4nzG__fieldValueVisible",
  "fieldWrap": "recurring-visual-module__Ig4nzG__fieldWrap",
  "form": "recurring-visual-module__Ig4nzG__form",
  "legend": "recurring-visual-module__Ig4nzG__legend",
  "legendDot": "recurring-visual-module__Ig4nzG__legendDot",
  "legendLabel": "recurring-visual-module__Ig4nzG__legendLabel",
  "legendValue": "recurring-visual-module__Ig4nzG__legendValue",
  "legendVisible": "recurring-visual-module__Ig4nzG__legendVisible",
  "monthLabel": "recurring-visual-module__Ig4nzG__monthLabel",
  "monthLabelMarked": "recurring-visual-module__Ig4nzG__monthLabelMarked",
  "option": "recurring-visual-module__Ig4nzG__option",
  "optionHighlighted": "recurring-visual-module__Ig4nzG__optionHighlighted",
  "placeholder": "recurring-visual-module__Ig4nzG__placeholder",
  "placeholderHidden": "recurring-visual-module__Ig4nzG__placeholderHidden",
  "root": "recurring-visual-module__Ig4nzG__root",
  "select": "recurring-visual-module__Ig4nzG__select",
});
